import GlobalSaveService from "@/services/GlobalSaveService.js"

export const namespaced = true
export const state = {
  SaveOperation: {},
  localDirtyFields: [],
  isSaving: false,
  dismissSecs: 3,
  dismissCountDown: 0,
  dismiss2Secs: 3,
  dismiss2CountDown: 0,
  showDismissibleAlert: false,
  localVariableName: "",
  localVariableObject: {},
  localFieldToSet: "",
  localReturnObject: "",
  localUrl: ""
}

export const mutations = {}

export const actions = {
  Save({ commit, getters, dispatch }, { _saveOp }) {
    if (_saveOp) {
      //console.log("FROM SAVE")
      //console.log(fields[0].FieldName)
      //console.log(user.FirstName)
      return GlobalSaveService.Save(_saveOp).then(response => {})
    } else {
      console.log("calling API")
    }
  },
  EmitSave({ commit, getters, dispatch }) {
    if (state.SaveOperation) {
      return GlobalSaveService.Save(state.SaveOperation).then(response => {})
    } else {
      console.log("ERROR")
    }
  },
  BuildSaveOperation() {
    state.SaveOperation = {
      Url: state.localUrl,
      ObjectToSet: state.localVariableObject,
      FieldToSet: state.localFieldToSet,
      ReturnObject: state.localReturnObject,
      Data: {
        [state.localVariableName]: state.localVariableObject,
        _newValues: state.localDirtyFields
      }
    }
    return state.SaveOperation
  },
  DestroySaveOperation() {
    (state.SaveOperation = {}),
      (state.localVariableName = ""),
      (state.localVariableObject = {}),
      (state.localFieldToSet = ""),
      (state.localReturnObject = ""),
      (state.localUrl = ""),
      (state.localDirtyFields = [])
    return true
  }
}

export const getters = {}
